$(function () {

    var mainSwiper = new Swiper ('.coliseum-el__cases-box .swiper-container', {
        // Optional parameters
        slidesPerView: 'auto',
        freeMode: true,
    })
});
